"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMonthStart = getMonthStart;
exports.getWeekStart = getWeekStart;
const dates = require("./dates");
function getMonthStart(timezone, month) {
    const now = timezone.getSimpleDateFromNow();
    if (month == 'this') {
        return now.getMonthBegin();
    }
    else if (month == 'next') {
        return now.nextMonthBegin();
    }
    else {
        return timezone.getSimpleDateFromString(month).getMonthBegin();
    }
}
function getWeekStart(timezone, week) {
    const now = timezone.getSimpleDateFromNow();
    const weekStart = dates.getWeekStart(now);
    if (week == 'this') {
        return weekStart;
    }
    else if (week == 'next') {
        return weekStart.addWeeks(1);
    }
    else if (week == 'prev') {
        return weekStart.addWeeks(-1);
    }
    else {
        return dates.getWeekStart(timezone.getSimpleDateFromString(week));
    }
}
